"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaParamsAvaCtrRecalcular = exports.yupParamsAvaCtrRecalcular = exports.schemaParamsAvaCtrConcluir = exports.yupParamsAvaCtrConcluir = exports.schemaParamsAvaCtrCreateOrUpdate = exports.yupParamsAvaCtrCreateOrUpdate = exports.schemaAvaCtr = exports.yupAvaCtr = void 0;
const yup = __importStar(require("yup"));
const utils_1 = require("../utils");
exports.yupAvaCtr = yup.object({
    idCurso: yup.number().positive().required().integer().label('Curso'),
    idSerie: yup.number().positive().required().integer().label('Série'),
    idTurma: yup.number().positive().required().integer().label('Turma'),
    idMateria: yup.number().positive().required().integer().label('Matéria'),
    bimestre: yup.number().positive().required().min(1).max(4).label('Etapa'),
    recalcular: yup.bool().required().default(false).label('Precisa recalcular'),
    concluido: yup.bool().required().default(false).label('Matéria concluída'),
    dataConc: (0, utils_1.sge2Date)().notRequired().nullable().default(null).label('Data da conclusão'),
});
exports.schemaAvaCtr = exports.yupAvaCtr.shape({});
exports.yupParamsAvaCtrCreateOrUpdate = yup
    .object({
    anoLetivo: yup.string().required().default('').label('Ano letivo'),
    concluido: yup.bool().notRequired().default(undefined).label('Matéria concluída'),
})
    .concat(exports.yupAvaCtr.pick(['bimestre', 'idCurso', 'idSerie', 'idTurma', 'idMateria']));
exports.schemaParamsAvaCtrCreateOrUpdate = exports.yupParamsAvaCtrCreateOrUpdate.shape({});
exports.yupParamsAvaCtrConcluir = yup
    .object({
    id: yup.number().required().positive().integer().label('ID'),
})
    .concat(exports.yupAvaCtr.pick(['concluido']));
exports.schemaParamsAvaCtrConcluir = exports.yupParamsAvaCtrConcluir.shape({});
exports.yupParamsAvaCtrRecalcular = yup
    .object({
    id: yup.number().required().positive().integer().label('ID'),
})
    .concat(exports.yupAvaCtr.pick(['recalcular']));
exports.schemaParamsAvaCtrRecalcular = exports.yupParamsAvaCtrRecalcular.shape({});
